import { Link } from 'react-router-dom';
import './Services.css'; 
let Services=(props)=>{
    return(
        <div className='servicesmaindiv'>
          <h2 className='serherd'>Services</h2>
           <div className='servicesmenu'>
            <Link  to='../MakeResume'><p><i className='bx bxs-user-detail'></i> Make Resume</p></Link>
                

            <Link  to='../Converter'><p><i className='bx bx-repost'></i> Converter</p></Link>

             <Link  to='../aadhaarcard-manual'><p><i className='bx bxs-id-card'></i>Aadhaar Manual</p></Link>

             <Link  to='../pan-manual'><p><i className='bx bx-id-card'></i> Pan Manual</p></Link>

             <Link to='../search-jobs.com'><p><i className='bx bx-id-card'></i>Latest Vacancy</p></Link>
  
             <Link to='../forms-filler-comp'><p><i className='bx bx-id-card'></i>Form Filler</p></Link>

             <Link to='../cyber-cafe-point'><p><i className='bx bx-id-card'></i>Cyber Cafe</p></Link>  
           </div>



           
        </div>
    );
}

export default Services;
